/* Chat maison du site — variante B « Mascotte support », choisie par Arthur le 2026-10-22 (projet claude/chat-site).

   Le visiteur parle à la boîte « PlanJapon Support » de ChatWoot (id 3, canal WebWidget) par l'API du widget
   (/api/v1/widget/*), sans jamais voir l'interface de ChatWoot. Même boîte, même IA (routine support-chat-planjapon),
   même équipe qu'avant : rien ne change derrière.

   - Rien ne part chez ChatWoot au chargement d'une page, sauf pour un visiteur qui a déjà une conversation.
   - Le jeton du visiteur est le cookie `cw_conversation` du widget d'avant : les conversations en cours continuent, et
     un retour au widget ChatWoot les retrouverait aussi.
   - Les réponses arrivent en direct par le WebSocket de ChatWoot (ActionCable, canal RoomChannel).
   - ChatWoot injoignable : le chat le dit et propose WhatsApp et l'e-mail ; le site, lui, ne casse jamais.
   - Les quatre cases de l'accueil ouvrent une réponse rapide écrite d'avance : rien ne part chez ChatWoot. L'IA ne
     travaille que quand le client écrit sa propre question (Arthur, 22/10 : pas de conversations ni de jetons pour rien).
   - Ne jamais envoyer d'adresse e-mail sans que le visiteur l'ait tapée : chez ChatWoot, elle fusionne le contact avec
     celui de même adresse (règle 6 de claude/chat-site/CLAUDE.md).

   Textes FR, EN et ES ci-dessous ; les 17 autres langues du site prennent l'anglais (la marque reste celle de la page). */
(function () {
  'use strict';

  var wrap = document.getElementById('pjChatWrap');
  var tab = document.getElementById('pjChatBub');
  var host = document.getElementById('pjChat');
  var cfgEl = document.getElementById('pjChatCfg');
  // `window.pjChat` est déjà l'élément <div id="pjChat"> (accès nommé du navigateur) : l'API s'appelle PJChat.
  if (!wrap || !tab || !host || !cfgEl || window.PJChat) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ------------------------------------------------------------------ textes */
  var I18N = {
    fr: {
      open: "Ouvrir le chat d'aide", close: 'Fermer', back: 'Retour', send: 'Envoyer', photo: 'Envoyer une photo',
      title: 'Service client {brand}', sub: 'Assistant IA · une personne peut prendre le relais', subTeam: 'Avec notre équipe',
      heroTitle: 'Une question ?', heroTitle2: 'On vous répond.',
      heroSub: "Un assistant IA répond jour et nuit. Une personne de l'équipe prend le relais si besoin.",
      delay: 'Répond en moins de 2 min', topics: 'Sujets fréquents',
      tiles: ['Mon téléphone est-il compatible ?', 'Installer mon eSIM', "Pas d'internet au Japon", 'Ma commande'],
      asks: ['Mon téléphone est-il compatible ?', 'Aidez-moi à installer mon eSIM', "Je n'ai pas internet", 'Une question sur ma commande'],
      write: 'Écrire un message', wa: 'Plutôt WhatsApp ?',
      privacy: "Vos messages sont envoyés à un modèle d'IA pour rédiger les réponses, et conservés dans l'historique de notre service client.",
      privacyLink: 'Politique de confidentialité',
      placeholder: 'Écrivez votre message…', today: "Aujourd'hui", yesterday: 'Hier',
      hello: "Bonjour ! Je suis l'assistant {brand}. Comment puis-je vous aider ?",
      aiLab: 'Réponse générée par IA', joined: "Une personne de notre équipe a rejoint la conversation. Elle voit tout l'échange.",
      team: '{name}, équipe {brand}', teamAnon: 'Équipe {brand}',
      typing: "L'assistant écrit…", teamTyping: '{name} écrit…',
      wait: 'Répond en général en moins de 2 minutes. Vous pouvez continuer votre visite : la réponse s\'affichera ici.',
      late: "Pas encore de réponse ? L'équipe vous répond ici dès que possible, ou sur WhatsApp.",
      works: 'Ça marche, merci !', human: 'Parler à une personne', humanText: "J'aimerais parler à une personne, s'il vous plaît.",
      mail: 'Vous partez ? Recevez la réponse par e-mail.', mailBtn: 'Mon e-mail', mailPh: 'votre@email.com', mailOk: 'OK',
      mailSaved: "C'est noté : la réponse vous parviendra aussi par e-mail.", mailBad: 'Cette adresse ne semble pas valide.',
      sending: 'Envoi…', failed: 'Pas envoyé.', retry: 'Réessayer',
      down: 'Le chat ne répond pas pour le moment', downSub: 'Écrivez-nous sur WhatsApp : la même équipe y répond.',
      orMail: 'ou par e-mail : {email}', loading: 'Chargement de la conversation…',
      tooBig: 'Photo trop lourde : 10 Mo au plus.', photoAlt: 'Photo envoyée', file: 'Fichier joint',
      unread1: '1 nouvelle réponse', unreadN: '{n} nouvelles réponses',
      quick: 'Réponse rapide', notAnswered: 'Ça ne répond pas à votre question ?', askOwn: 'Poser ma question',
      // Les réponses rapides des quatre cases : écrites d'avance d'après la base du support (fiches 02, 03, 08),
      // affichées sans rien envoyer à ChatWoot. L'IA ne travaille que si le client écrit sa propre question.
      answers: [
        { link: 'compat', label: 'Vérifier mon modèle', pts: [
          "iPhone : compatible depuis l'iPhone XS et XR (2018). Samsung : Galaxy S20 et plus récents, tous les Z Flip et Z Fold. Google : Pixel 3 et plus récents.",
          "Pour en être sûr, composez *#06# : si un numéro EID s'affiche, votre téléphone gère l'eSIM.",
          "Il doit aussi être déverrouillé. Sur iPhone : Réglages → Général → Informations → « Verrouillage de l'opérateur » doit indiquer « Aucune restriction ».",
          "Attention aux téléphones achetés en Chine continentale, à Hong Kong ou à Macao : beaucoup n'ont pas d'eSIM."] },
        { link: 'tuto2', label: 'Voir le tuto, écran par écran', pts: [
          "Installez-la avant de partir, chez vous en Wi-Fi : scannez le QR code reçu par e-mail, ou touchez « Installer mon eSIM » dans l'e-mail depuis votre iPhone.",
          "Laissez ensuite la ligne désactivée (« Activer ce numéro » coupé) jusqu'à l'atterrissage : elle ne consomme rien d'ici là.",
          "À l'arrivée : réactivez la ligne, activez « Données à l'étranger » sur cette ligne, et choisissez-la pour les données cellulaires."] },
        { link: 'tuto1', label: 'Voir le tuto vidéo', pts: [
          "Vérifiez que la ligne de votre eSIM est activée, et que c'est elle qui est choisie pour « Données cellulaires ».",
          "Activez « Données à l'étranger » sur cette ligne (« Données en itinérance » sur Samsung).",
          "Toujours rien ? Coupez la ligne 30 secondes puis réactivez-la (ou passez 30 secondes en mode avion), puis redémarrez le téléphone."] },
        { link: '', label: '', pts: [
          "Votre eSIM arrive par e-mail : en quelques minutes pour une eSIM data, parfois en plusieurs heures pour une eSIM illimitée.",
          "Pas reçue ? Regardez dans vos spams et l'onglet Promotions, et vérifiez l'adresse saisie à la commande.",
          "Une autre question sur votre commande ? Écrivez-nous avec votre numéro de commande."] }
      ]
    },
    en: {
      open: 'Open support chat', close: 'Close', back: 'Back', send: 'Send', photo: 'Send a photo',
      title: '{brand} support', sub: 'AI assistant · a person can take over', subTeam: 'With our team',
      heroTitle: 'A question?', heroTitle2: "We've got you.",
      heroSub: 'An AI assistant answers day and night. A person from our team takes over when needed.',
      delay: 'Answers within 2 min', topics: 'Common topics',
      tiles: ['Is my phone compatible?', 'Install my eSIM', 'No internet in Japan', 'My order'],
      asks: ['Is my phone compatible?', 'Help me install my eSIM', 'I have no internet', 'A question about my order'],
      write: 'Write a message', wa: 'Prefer WhatsApp?',
      privacy: 'Your messages are sent to an AI model to write the answers, and kept in our support history.',
      privacyLink: 'Privacy Policy',
      placeholder: 'Write your message…', today: 'Today', yesterday: 'Yesterday',
      hello: "Hello! I'm the {brand} assistant. How can I help?",
      aiLab: 'AI-generated answer', joined: 'A member of our team has joined. They can see the whole conversation.',
      team: '{name}, {brand} team', teamAnon: '{brand} team',
      typing: 'The assistant is writing…', teamTyping: '{name} is writing…',
      wait: 'Usually answers within 2 minutes. You can keep browsing: the answer will show up here.',
      late: 'No answer yet? Our team will reply here as soon as possible, or on WhatsApp.',
      works: 'It works, thank you!', human: 'Talk to a person', humanText: "I'd like to talk to a person, please.",
      mail: 'Leaving? Get the answer by email.', mailBtn: 'My email', mailPh: 'your@email.com', mailOk: 'OK',
      mailSaved: "Noted: you'll also get the answer by email.", mailBad: "This address doesn't look valid.",
      sending: 'Sending…', failed: 'Not sent.', retry: 'Try again',
      down: "The chat isn't answering right now", downSub: 'Write to us on WhatsApp: the same team answers there.',
      orMail: 'or by email: {email}', loading: 'Loading the conversation…',
      tooBig: 'Photo too large: 10 MB maximum.', photoAlt: 'Photo sent', file: 'Attached file',
      unread1: '1 new answer', unreadN: '{n} new answers',
      quick: 'Quick answer', notAnswered: "Didn't answer your question?", askOwn: 'Ask my question',
      answers: [
        { link: 'compat', label: 'Check my model', pts: [
          'iPhone: compatible since the iPhone XS and XR (2018). Samsung: Galaxy S20 and newer, every Z Flip and Z Fold. Google: Pixel 3 and newer.',
          'To be sure, dial *#06#: if an EID number shows up, your phone supports eSIM.',
          'It must also be carrier-unlocked. On iPhone: Settings → General → About → “Carrier Lock” should say “No SIM restrictions”.',
          'Careful with phones bought in mainland China, Hong Kong or Macao: many have no eSIM.'] },
        { link: 'tuto2', label: 'Watch the tutorial, screen by screen', pts: [
          'Install it before you leave, at home on Wi-Fi: scan the QR code from your email, or tap “Install my eSIM” in the email on your iPhone.',
          'Then keep the line turned off (“Turn On This Line” off) until you land: it uses nothing until then.',
          'On landing: turn the line back on, turn on “Data Roaming” for that line, and choose it for Cellular Data.'] },
        { link: 'tuto1', label: 'Watch the video tutorial', pts: [
          'Check that your eSIM line is turned on, and that it is the one selected for “Cellular Data”.',
          'Turn on “Data Roaming” for that line.',
          'Still nothing? Turn the line off for 30 seconds and back on (or airplane mode for 30 seconds), then restart your phone.'] },
        { link: '', label: '', pts: [
          'Your eSIM arrives by email: within minutes for a data eSIM, sometimes several hours for an unlimited eSIM.',
          'Not received? Check your spam and the Promotions tab, and the email address entered at checkout.',
          'Another question about your order? Write to us with your order number.'] }
      ]
    },
    es: {
      open: 'Abrir el chat de ayuda', close: 'Cerrar', back: 'Volver', send: 'Enviar', photo: 'Enviar una foto',
      title: 'Atención al cliente de {brand}', sub: 'Asistente de IA · una persona puede tomar el relevo', subTeam: 'Con nuestro equipo',
      heroTitle: '¿Una pregunta?', heroTitle2: 'Te respondemos.',
      heroSub: 'Un asistente de IA responde de día y de noche. Una persona del equipo toma el relevo si hace falta.',
      delay: 'Responde en menos de 2 min', topics: 'Temas frecuentes',
      tiles: ['¿Mi teléfono es compatible?', 'Instalar mi eSIM', 'Sin internet en Japón', 'Mi pedido'],
      asks: ['¿Mi teléfono es compatible?', 'Ayúdame a instalar mi eSIM', 'No tengo internet', 'Una pregunta sobre mi pedido'],
      write: 'Escribir un mensaje', wa: '¿Prefieres WhatsApp?',
      privacy: 'Tus mensajes se envían a un modelo de IA para redactar las respuestas y se guardan en el historial de nuestro servicio de atención.',
      privacyLink: 'Política de privacidad',
      placeholder: 'Escribe tu mensaje…', today: 'Hoy', yesterday: 'Ayer',
      hello: '¡Hola! Soy el asistente de {brand}. ¿En qué puedo ayudarte?',
      aiLab: 'Respuesta generada por IA', joined: 'Una persona de nuestro equipo se ha unido. Puede ver toda la conversación.',
      team: '{name}, equipo de {brand}', teamAnon: 'Equipo de {brand}',
      typing: 'El asistente está escribiendo…', teamTyping: '{name} está escribiendo…',
      wait: 'Suele responder en menos de 2 minutos. Puedes seguir navegando: la respuesta aparecerá aquí.',
      late: '¿Aún sin respuesta? El equipo te responderá aquí lo antes posible, o por WhatsApp.',
      works: '¡Funciona, gracias!', human: 'Hablar con una persona', humanText: 'Me gustaría hablar con una persona, por favor.',
      mail: '¿Te vas? Recibe la respuesta por correo.', mailBtn: 'Mi correo', mailPh: 'tu@correo.com', mailOk: 'OK',
      mailSaved: 'Anotado: también recibirás la respuesta por correo.', mailBad: 'Esta dirección no parece válida.',
      sending: 'Enviando…', failed: 'No enviado.', retry: 'Reintentar',
      down: 'El chat no responde en este momento', downSub: 'Escríbenos por WhatsApp: el mismo equipo responde allí.',
      orMail: 'o por correo: {email}', loading: 'Cargando la conversación…',
      tooBig: 'Foto demasiado pesada: 10 MB como máximo.', photoAlt: 'Foto enviada', file: 'Archivo adjunto',
      unread1: '1 respuesta nueva', unreadN: '{n} respuestas nuevas',
      quick: 'Respuesta rápida', notAnswered: '¿No responde a tu pregunta?', askOwn: 'Hacer mi pregunta',
      answers: [
        { link: 'compat', label: 'Comprobar mi modelo', pts: [
          'iPhone: compatible desde el iPhone XS y XR (2018). Samsung: Galaxy S20 y posteriores, todos los Z Flip y Z Fold. Google: Pixel 3 y posteriores.',
          'Para estar seguro, marca *#06#: si aparece un número EID, tu teléfono admite eSIM.',
          'También debe estar libre de operador. En iPhone: Ajustes → General → Información → «Bloqueo del operador» debe indicar «Sin restricción de SIM».',
          'Cuidado con los teléfonos comprados en China continental, Hong Kong o Macao: muchos no tienen eSIM.'] },
        { link: 'tuto2', label: 'Ver el tutorial, pantalla a pantalla', pts: [
          'Instálala antes de salir, en casa con Wi-Fi: escanea el código QR del correo, o toca «Instalar mi eSIM» en el correo desde tu iPhone.',
          'Luego deja la línea desactivada («Activar esta línea» apagado) hasta el aterrizaje: no consume nada hasta entonces.',
          'Al llegar: vuelve a activar la línea, activa la «Itinerancia de datos» en esa línea y elígela en «Datos móviles».'] },
        { link: 'tuto1', label: 'Ver el tutorial en vídeo', pts: [
          'Comprueba que la línea de tu eSIM está activada y que es la elegida en «Datos móviles».',
          'Activa la «Itinerancia de datos» en esa línea.',
          '¿Sigue sin funcionar? Apaga la línea 30 segundos y vuelve a activarla (o modo avión 30 segundos), y reinicia el teléfono.'] },
        { link: '', label: '', pts: [
          'Tu eSIM llega por correo: en minutos para una eSIM de datos, a veces en varias horas para una eSIM ilimitada.',
          '¿No la recibiste? Revisa el spam y la pestaña Promociones, y el correo indicado en el pedido.',
          '¿Otra pregunta sobre tu pedido? Escríbenos con tu número de pedido.'] }
      ]
    }
  };
  var LANG = I18N[CFG.lang] ? CFG.lang : 'en';
  var L = I18N[LANG];
  // Typographie française, comme le snippet pj-fr-typo : espaces insécables, traits d'union qui ne coupent pas.
  if (LANG === 'fr') {
    var NB = ' ', NBH = '‑';
    var fr = function (s) {
      return s.replace(/ ([?!:;»])/g, NB + '$1').replace(/« /g, '«' + NB)
        .replace(/([A-Za-zÀ-ÿ])-(je|il|elle|vous|on|mail)(?![A-Za-zÀ-ÿ])/g, '$1' + NBH + '$2');
    };
    var typo = function (v) {
      if (typeof v === 'string') return fr(v);
      if (Array.isArray(v)) return v.map(typo);
      if (v && typeof v === 'object') { Object.keys(v).forEach(function (k) { v[k] = typo(v[k]); }); return v; }
      return v;
    };
    typo(L);
  }
  function tr(key, vars) {
    var s = L[key] || '';
    vars = vars || {};
    vars.brand = vars.brand || CFG.brand;
    return s.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
  }

  /* ------------------------------------------------------------------ utilitaires */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Le texte d'un message : échappé, puis gras (**…**), liens et retours à la ligne. Rien d'autre n'est interprété.
  function rich(s) {
    var out = esc(s).replace(/\*\*([^*\n]+)\*\*/g, '<b>$1</b>');
    out = out.replace(/(https?:\/\/[^\s<]+|(?:www\.)?(?:planjapon|esimjp|esimjapon)\.com(?:\/[^\s<]*)?)/g, function (m) {
      var trail = '';
      while (/[.,;:!?)»]$/.test(m)) { trail = m.slice(-1) + trail; m = m.slice(0, -1); }
      var href = /^https?:/.test(m) ? m : 'https://' + m;
      var here = href.indexOf('//' + location.host + '/') > 0 || href === 'https://' + location.host;
      // Le lien se lit sans « https:// » ni « www. » : planjapon.com/pages/… suffit à le reconnaître.
      var vu = m.replace(/^https?:\/\//, '').replace(/^www\./, '');
      return '<a href="' + href + '"' + (here ? '' : ' target="_blank" rel="noopener"') + '>' + vu + '</a>' + trail;
    });
    return out.replace(/\n/g, '<br>');
  }
  function icon(n) { return '<svg class="pjc-ic" aria-hidden="true"><use href="#pjc-i-' + n + '"/></svg>'; }
  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem('pj_chat') || '{}') || {}; } catch (e) { return {}; } },
    set: function (p) {
      var m = store.get();
      Object.keys(p).forEach(function (k) { m[k] = p[k]; });
      try { localStorage.setItem('pj_chat', JSON.stringify(m)); } catch (e) {}
    }
  };
  var COOKIE = 'cw_conversation';
  function readCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(n, v, days) {
    var d = new Date(Date.now() + days * 864e5);
    document.cookie = n + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }
  function now() { return Math.floor(Date.now() / 1000); }

  /* ------------------------------------------------------------------ état */
  var S = {
    auth: readCookie(COOKIE), pubsub: null, email: null, conv: null, status: null,
    msgs: [], pending: [], loaded: false, loading: null, down: false,
    open: false, view: 'home', unread: 0, typing: null, typingTimer: null, mailOpen: false, mailMsg: null
  };
  var mobile = window.matchMedia('(max-width: 760px)');

  /* ------------------------------------------------------------------ réseau */
  function req(method, path, body, opt) {
    opt = opt || {};
    var url = CFG.base + path + '?website_token=' + encodeURIComponent(CFG.token) + '&locale=' + LANG;
    var headers = {};
    if (S.auth) headers['X-Auth-Token'] = S.auth;
    var payload = body;
    if (body && !(body instanceof FormData)) { headers['Content-Type'] = 'application/json'; payload = JSON.stringify(body); }
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, opt.timeout || 20000) : null;
    return fetch(url, { method: method, headers: headers, body: payload, credentials: 'omit', mode: 'cors', signal: ctl ? ctl.signal : undefined })
      .then(function (r) {
        if (timer) clearTimeout(timer);
        if (!r.ok) { var err = new Error('ChatWoot ' + r.status); err.status = r.status; throw err; }
        return r.status === 204 ? null : r.text().then(function (t) { return t ? JSON.parse(t) : null; });
      }, function (e) {
        if (timer) clearTimeout(timer);
        var err = new Error('réseau'); err.status = 0; err.cause = e; throw err;
      });
  }

  // Le contact du visiteur : repris par son jeton s'il en a un, créé sinon. ChatWoot rend un jeton neuf à chaque fois
  // (180 jours) et le canal du temps réel (`pubsub_token`).
  var contactP = null;
  function ensureContact() {
    if (S.pubsub && S.auth) return Promise.resolve();
    if (contactP) return contactP;
    contactP = req('POST', '/api/v1/widget/config').then(function (r) {
      var tok = r && r.website_channel_config && r.website_channel_config.auth_token;
      if (!tok || !r.contact) throw Object.assign(new Error('config'), { status: 500 });
      S.auth = tok;
      S.pubsub = r.contact.pubsub_token;
      S.email = r.contact.email || null;
      S.allowAfter = r.website_channel_config.allow_messages_after_resolved;
      writeCookie(COOKIE, tok, 365);
      S.down = false;
    }).catch(function (e) { S.down = e.status === 0 || e.status >= 500; throw e; })
      .then(function (v) { contactP = null; return v; }, function (e) { contactP = null; throw e; });
    return contactP;
  }

  // Le fil d'un visiteur qui a déjà un jeton : la dernière conversation et ses messages.
  function loadThread() {
    if (!S.auth) return Promise.resolve();
    if (S.loading) return S.loading;
    S.loading = ensureContact()
      .then(function () {
        return Promise.all([req('GET', '/api/v1/widget/messages'), req('GET', '/api/v1/widget/conversations')]);
      })
      .then(function (r) {
        var list = (r[0] && r[0].payload) || [];
        S.msgs = [];
        list.forEach(upsert);
        var c = r[1] || {};
        if (c.id) { S.conv = c.id; S.status = c.status; }
        S.loaded = true;
        S.down = false;
        computeUnread(c.contact_last_seen_at);
        if (S.conv) cable();
      })
      .catch(function (e) {
        if (e.status === 404 || e.status === 401) {
          // Jeton inconnu ou périmé : on repart comme un nouveau visiteur, sans rien casser.
          S.auth = null; S.pubsub = null; S.msgs = []; S.conv = null; S.loaded = true;
        } else { S.down = true; }
      })
      .then(function () { S.loading = null; render(); });
    return S.loading;
  }

  /* ------------------------------------------------------------------ messages */
  var HIDDEN_TYPES = ['input_csat', 'input_email'];
  function norm(m) {
    if (!m || m.private || m.message_type === 2 || m.message_type === 'activity') return null;
    if (HIDDEN_TYPES.indexOf(m.content_type) >= 0) return null;
    if (m.content_attributes && m.content_attributes.deleted) return null;
    var mt = typeof m.message_type === 'string' ? { incoming: 0, outgoing: 1, template: 3 }[m.message_type] : m.message_type;
    var s = m.sender || {};
    var who;
    if (mt === 0) who = 'me';
    else if (s.type === 'agent_bot' || s.type === 'captain_assistant') who = 'ai';
    else if (s.type === 'user') who = 'team';
    else who = 'support';
    var name = who === 'team' ? String(s.available_name || s.name || '').trim().split(/\s+/)[0] : '';
    var atts = (m.attachments || []).filter(function (a) { return a && a.data_url; }).map(function (a) {
      return { kind: a.file_type === 'image' ? 'image' : 'file', url: a.data_url, thumb: a.thumb_url || a.data_url, ext: a.extension || '' };
    });
    if (!m.content && !atts.length) return null;
    return {
      id: m.id, conv: m.conversation_id, at: m.created_at || now(), who: who, name: name,
      text: m.content || '', atts: atts, echo: m.echo_id || null
    };
  }
  function upsert(raw) {
    var m = norm(raw);
    if (!m) return null;
    for (var i = 0; i < S.msgs.length; i++) if (S.msgs[i].id === m.id) { S.msgs[i] = m; return m; }
    S.msgs.push(m);
    S.msgs.sort(function (a, b) { return a.at - b.at || a.id - b.id; });
    if (m.echo) S.pending = S.pending.filter(function (p) { return p.echo !== m.echo; });
    return m;
  }
  function lastSupport() {
    for (var i = S.msgs.length - 1; i >= 0; i--) if (S.msgs[i].who !== 'me') return S.msgs[i];
    return null;
  }
  function computeUnread(lastSeenAt) {
    var seen = store.get().seen || 0;
    var since = Math.max(lastSeenAt || 0, 0);
    S.unread = S.msgs.filter(function (m) { return m.who !== 'me' && m.id > seen && m.at > since; }).length;
    if (S.open && S.view === 'chat') S.unread = 0;
    badge();
  }
  function badge() {
    var b = wrap.querySelector('.pjc-tab__badge');
    if (!b) return;
    if (S.unread > 0) {
      b.hidden = false;
      b.textContent = S.unread > 9 ? '9+' : String(S.unread);
      tab.setAttribute('aria-label', tr('open') + ' · ' + (S.unread === 1 ? tr('unread1') : tr('unreadN', { n: S.unread })));
    } else {
      b.hidden = true;
      tab.setAttribute('aria-label', tr('open'));
    }
  }
  var seenT = 0;
  function markSeen() {
    var last = lastSupport();
    if (last) store.set({ seen: last.id });
    S.unread = 0;
    badge();
    if (!S.conv || !S.auth || Date.now() - seenT < 8000) return;
    seenT = Date.now();
    req('POST', '/api/v1/widget/conversations/update_last_seen').catch(function () {});
  }

  /* ------------------------------------------------------------------ envoi */
  function pageUrl() { return location.origin + location.pathname; }   // jamais la requête : elle peut porter des données
  function attrs() {
    var a = { source: 'chat-site', locale: LANG, langue_site: CFG.locale, page: location.pathname, gabarit: CFG.page };
    if (CFG.market) a.marche = CFG.market;
    if (CFG.currency) a.devise = CFG.currency;
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
      if (c && c.items && c.items.length) {
        a.panier = c.items.slice(0, 5).map(function (i) {
          return i.quantity + ' × ' + i.product_title + (i.variant_title ? ' — ' + i.variant_title : '');
        }).join(' ; ').slice(0, 250);
      }
      return a;
    }, function () { return a; });
  }
  function echoId() { return 'pj' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }

  function send(text, file) {
    // Les espaces et traits insécables servent à l'affichage : ChatWoot reçoit le texte tel qu'on le taperait.
    text = (text || '').replace(/‑/g, '-').replace(/[  ]/g, ' ').trim();
    if (!text && !file) return;
    var p = { echo: echoId(), text: text, file: file || null, preview: file ? URL.createObjectURL(file) : null, state: 'sending', at: now() };
    S.pending.push(p);
    S.view = 'chat';
    render();
    deliver(p);
  }
  // Conversation résolue, et boîte réglée pour refuser d'y répondre : le message suivant en ouvre une nouvelle.
  function closedConv() { return !!S.conv && S.status === 'resolved' && S.allowAfter === false; }
  function newConv(p, a) {
    return req('POST', '/api/v1/widget/conversations', {
      contact: {}, custom_attributes: a,
      message: { content: p.text, timestamp: new Date().toString(), referer_url: pageUrl() }
    }).then(function (c) {
      S.conv = c.id; S.status = c.status;
      S.pending = S.pending.filter(function (x) { return x !== p; });
      (c.messages || []).forEach(upsert);
    });
  }
  function deliver(p) {
    p.state = 'sending';
    renderList();
    var first = !S.conv;
    ensureContact()
      .then(function () { return first || closedConv() ? attrs() : null; })
      .then(function (a) { return closedConv() && !p.file ? newConv(p, a) : post(p, a); })
      .catch(function (e) {
        // Le réglage a changé entre-temps : ChatWoot refuse (403), on ouvre la nouvelle conversation.
        if (e.status === 403 && !p.file) return attrs().then(function (a) { return newConv(p, a); });
        throw e;
      })
      .then(function () {
        store.set({ conv: now() });
        cable();
        render();
      })
      .catch(function (e) {
        p.state = 'failed';
        if (e.status === 0 && !S.auth) S.down = true;
        render();
      });
  }
  function post(p, a) {
    var body;
    if (p.file) {
      body = new FormData();
      body.append('message[attachments][]', p.file, p.file.name || 'photo.jpg');
      if (p.text) body.append('message[content]', p.text);
      body.append('message[timestamp]', new Date().toString());
      body.append('message[referer_url]', pageUrl());
      body.append('message[echo_id]', p.echo);
      if (a) Object.keys(a).forEach(function (k) { body.append('custom_attributes[' + k + ']', a[k]); });
    } else {
      body = { message: { content: p.text, timestamp: new Date().toString(), referer_url: pageUrl(), echo_id: p.echo } };
      if (a) body.custom_attributes = a;
    }
    return req('POST', '/api/v1/widget/messages', body, { timeout: p.file ? 90000 : 20000 }).then(function (m) {
      if (m && m.conversation_id) S.conv = m.conversation_id;
      if (m) { m.echo_id = p.echo; upsert(m); }
      S.pending = S.pending.filter(function (x) { return x !== p; });
    });
  }

  // Une photo de téléphone pèse souvent 3 à 6 Mo : réduite à 2048 px en JPEG, elle part vite même depuis l'Asie.
  function shrink(file) {
    return new Promise(function (resolve) {
      if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size < 900000) return resolve(file);
      var img = new Image();
      var u = URL.createObjectURL(file);
      img.onload = function () {
        var k = Math.min(1, 2048 / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(u);
        c.toBlob(function (b) {
          resolve(b && b.size < file.size ? new File([b], (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file);
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(u); resolve(file); };
      img.src = u;
    });
  }

  /* ------------------------------------------------------------------ temps réel (ActionCable) */
  var ws = null, sub = null, lastPing = 0, retry = 0, pingT = null, presT = null, cableOff = false;
  function cable() {
    if (!S.pubsub || cableOff || (ws && ws.readyState <= 1)) return;
    if (!window.WebSocket) return;
    var ident = JSON.stringify({ channel: 'RoomChannel', pubsub_token: S.pubsub });
    try { ws = new WebSocket(CFG.base.replace(/^http/, 'ws') + '/cable', ['actioncable-v1-json', 'actioncable-unsupported']); }
    catch (e) { return; }
    sub = false;
    ws.onmessage = function (ev) {
      var d; try { d = JSON.parse(ev.data); } catch (e) { return; }
      if (d.type === 'welcome') { ws.send(JSON.stringify({ command: 'subscribe', identifier: ident })); lastPing = Date.now(); return; }
      if (d.type === 'ping') { lastPing = Date.now(); return; }
      if (d.type === 'confirm_subscription') { sub = true; retry = 0; presence(); return; }
      if (d.type === 'disconnect' || d.type === 'reject_subscription') { ws.close(); return; }
      if (d.message && d.message.event) onEvent(d.message.event, d.message.data || {});
    };
    ws.onclose = function () {
      ws = null; sub = false;
      if (cableOff) return;
      var wait = [1000, 2000, 5000, 10000, 30000][Math.min(retry++, 4)];
      setTimeout(function () { if (!document.hidden) { cable(); resync(); } }, wait);
    };
    clearInterval(pingT);
    // ChatWoot pingue toutes les 3 s : 12 s de silence = connexion morte (Wi-Fi d'hôtel, onglet endormi).
    pingT = setInterval(function () { if (ws && ws.readyState === 1 && Date.now() - lastPing > 12000) ws.close(); }, 4000);
  }
  // « En ligne » côté ChatWoot : tant que le visiteur est là, la réponse n'a pas à partir par e-mail.
  function presence() {
    clearInterval(presT);
    var ident = JSON.stringify({ channel: 'RoomChannel', pubsub_token: S.pubsub });
    var tick = function () {
      if (ws && ws.readyState === 1 && sub) ws.send(JSON.stringify({ command: 'message', identifier: ident, data: JSON.stringify({ action: 'update_presence' }) }));
    };
    tick();
    presT = setInterval(tick, 60000);
  }
  var resyncT = 0;
  function resync() {
    if (!S.auth || Date.now() - resyncT < 5000) return;
    resyncT = Date.now();
    req('GET', '/api/v1/widget/messages').then(function (r) {
      ((r && r.payload) || []).forEach(upsert);
      if (!S.open || S.view !== 'chat') computeUnread(); else markSeen();
      render();
    }).catch(function () {});
  }
  function onEvent(ev, d) {
    if (ev === 'message.created' || ev === 'message.updated') {
      if (S.conv && d.conversation_id && d.conversation_id < S.conv) return;
      if (d.conversation_id) S.conv = d.conversation_id;
      var m = upsert(d);
      if (m && m.who !== 'me') {
        S.typing = null;
        if (ev === 'message.created') {
          if (S.open && S.view === 'chat' && !document.hidden) markSeen();
          else { S.unread++; badge(); }
        }
      }
      render();
    } else if (ev === 'conversation.typing_on' || ev === 'conversation.typing_off') {
      if (d.is_private) return;
      var u = d.user || {};
      if (u.type === 'contact') return;
      S.typing = ev === 'conversation.typing_on' ? (u.type === 'user' ? String(u.available_name || u.name || '').split(' ')[0] || '…' : 'ai') : null;
      clearTimeout(S.typingTimer);
      if (S.typing) S.typingTimer = setTimeout(function () { S.typing = null; renderList(); }, 30000);
      renderList();
    } else if (ev === 'conversation.status_changed' || ev === 'conversation.created') {
      if (d.id && (!S.conv || d.id >= S.conv)) { S.conv = d.id; S.status = d.status; }
    }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    if (S.auth && S.loaded && S.conv) { cable(); resync(); }
  });

  /* ------------------------------------------------------------------ rendu */
  var SPRITE = '<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs>' +
    '<symbol id="pjc-i-chat" viewBox="0 0 24 24"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.8A8 8 0 1 1 21 12Z"/><path d="M8.5 11h7M8.5 14.5h4.5"/></symbol>' +
    '<symbol id="pjc-i-x" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></symbol>' +
    '<symbol id="pjc-i-up" viewBox="0 0 24 24"><path d="M12 19V5M5.5 11.5 12 5l6.5 6.5"/></symbol>' +
    '<symbol id="pjc-i-plus" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></symbol>' +
    '<symbol id="pjc-i-left" viewBox="0 0 24 24"><path d="M15 5.5 8.5 12l6.5 6.5"/></symbol>' +
    '<symbol id="pjc-i-spark" viewBox="0 0 24 24"><path d="M12 3c.6 4.4 2.6 6.4 7 7-4.4.6-6.4 2.6-7 7-.6-4.4-2.6-6.4-7-7 4.4-.6 6.4-2.6 7-7Z"/><path d="M19 16.5c.2 1.4.8 2 2.2 2.2-1.4.2-2 .8-2.2 2.2-.2-1.4-.8-2-2.2-2.2 1.4-.2 2-.8 2.2-2.2Z"/></symbol>' +
    '<symbol id="pjc-i-user" viewBox="0 0 24 24"><circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20c1.2-3.6 4-5.4 7.5-5.4s6.3 1.8 7.5 5.4"/></symbol>' +
    '<symbol id="pjc-i-wifioff" viewBox="0 0 24 24"><path d="M3 3l18 18"/><path d="M8.6 13.2a5 5 0 0 1 5.6-.6M5 9.6a10 10 0 0 1 4-2.2M12.9 7.1A10 10 0 0 1 19 9.6"/><path d="M12 18.5h.01"/></symbol>' +
    '<symbol id="pjc-i-phone" viewBox="0 0 24 24"><rect x="6.5" y="2.5" width="11" height="19" rx="2.6"/><path d="M10.5 18.5h3"/></symbol>' +
    '<symbol id="pjc-i-box" viewBox="0 0 24 24"><path d="M4 7.5 12 3.5l8 4v9l-8 4-8-4v-9Z"/><path d="m4 7.5 8 4 8-4M12 11.5v9"/></symbol>' +
    '<symbol id="pjc-i-qr" viewBox="0 0 24 24"><rect x="4" y="4" width="6.5" height="6.5" rx="1.4"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.4"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.4"/><path d="M13.5 13.5h2.5v2.5M20 13.5v.01M16 20h4v-3.2"/></symbol>' +
    '<symbol id="pjc-i-mail" viewBox="0 0 24 24"><rect x="3.5" y="5.5" width="17" height="13" rx="2.6"/><path d="m4.5 7 7.5 6 7.5-6"/></symbol>' +
    '<symbol id="pjc-i-file" viewBox="0 0 24 24"><path d="M6.5 3.5h7l4 4v13h-11v-17Z"/><path d="M13.5 3.5v4h4"/></symbol>' +
    '<symbol id="pjc-i-retry" viewBox="0 0 24 24"><path d="M19.5 12a7.5 7.5 0 1 1-2.2-5.3"/><path d="M19.5 4.5v4h-4"/></symbol>' +
    '<symbol id="pjc-i-check" viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></symbol>' +
    '</defs></svg>';
  var TILE_ICONS = ['phone', 'qr', 'wifioff', 'box'];

  var built = false, panel = null, listEl = null, input = null, fileIn = null;
  function build() {
    if (built) return;
    built = true;
    host.innerHTML = SPRITE + '<div class="pjc-back" data-close></div>' +
      '<section class="pjc-panel" role="dialog" aria-label="' + esc(tr('title')) + '"></section>' +
      '<input type="file" accept="image/*" class="pjc-file" hidden>';
    panel = host.querySelector('.pjc-panel');
    fileIn = host.querySelector('.pjc-file');
    host.addEventListener('click', onClick);
    host.addEventListener('keydown', onKey);
    host.addEventListener('input', onInput);
    fileIn.addEventListener('change', function () {
      var f = fileIn.files && fileIn.files[0];
      fileIn.value = '';
      if (!f) return;
      shrink(f).then(function (g) {
        if (g.size > 10 * 1024 * 1024) { S.notice = tr('tooBig'); renderList(); return; }
        var t = input ? input.value : '';
        if (input) { input.value = ''; autosize(); }
        send(t, g);
      });
    });
  }

  function homeHTML() {
    var tiles = L.tiles.map(function (label, i) {
      return '<button type="button" class="pjc-tile" data-ans="' + i + '"><span class="pjc-pic">' + icon(TILE_ICONS[i]) + '</span>' + esc(label) + '</button>';
    }).join('');
    return '<div class="pjc-view pjc-home">' +
      '<div class="pjc-hero"><div class="pjc-hero__t"><h2>' + esc(L.heroTitle) + '<em>' + esc(L.heroTitle2) + '</em></h2>' +
      '<p>' + esc(L.heroSub) + '</p><span class="pjc-pill"><i></i>' + esc(L.delay) + '</span></div>' +
      '<img src="' + esc(CFG.mascot) + '" alt="" width="108" height="117">' +
      '<button type="button" class="pjc-x" data-close aria-label="' + esc(L.close) + '">' + icon('x') + '</button></div>' +
      '<div class="pjc-sec">' + esc(L.topics) + '</div><div class="pjc-tiles">' + tiles + '</div>' +
      '<button type="button" class="pjc-cta" data-write>' + icon('chat') + esc(L.write) + '</button>' +
      '<a class="pjc-wa" href="' + esc(CFG.whatsapp) + '" target="_blank" rel="noopener"><img src="' + esc(CFG.waIcon) + '" alt="" width="18" height="18">' + esc(L.wa) + '</a>' +
      '<div class="pjc-grow"></div>' + privacyHTML() + '</div>';
  }
  // Une réponse rapide : affichée ici, rien ne part chez ChatWoot. « Poser ma question » ouvre la conversation.
  function answerLink(a) {
    var base = a.link === 'compat' ? CFG.links && CFG.links.compat : (CFG.links && CFG.links.tuto);
    if (!a.link || !base) return '';
    return base + (a.link === 'tuto2' ? '#tuto-v2' : a.link === 'tuto1' ? '#tuto-v1' : '');
  }
  function answerHTML(i) {
    var a = L.answers[i] || L.answers[0];
    var href = answerLink(a);
    return '<div class="pjc-view pjc-answerv">' +
      '<header class="pjc-h"><button type="button" class="pjc-iconbtn" data-home aria-label="' + esc(L.back) + '">' + icon('left') + '</button>' +
      '<span class="pjc-av"><img src="' + esc(CFG.head) + '" alt=""></span>' +
      '<span class="pjc-ht"><b>' + esc(tr('title')) + '</b><small>' + esc(L.quick) + '</small></span>' +
      '<button type="button" class="pjc-iconbtn" data-close aria-label="' + esc(L.close) + '">' + icon('x') + '</button></header>' +
      '<div class="pjc-ans"><div class="pjc-ans__q"><span class="pjc-pic">' + icon(TILE_ICONS[i]) + '</span><h2>' + esc(L.asks[i]) + '</h2></div>' +
      '<ul class="pjc-ans__list">' + a.pts.map(function (p) { return '<li>' + icon('check') + '<span>' + esc(p) + '</span></li>'; }).join('') + '</ul>' +
      (href ? '<a class="pjc-ans__link" href="' + esc(href) + '">' + esc(a.label) + ' →</a>' : '') + '</div>' +
      '<div class="pjc-grow"></div>' +
      '<div class="pjc-ans__more"><p>' + esc(L.notAnswered) + '</p>' +
      '<button type="button" class="pjc-cta" data-write>' + icon('chat') + esc(L.askOwn) + '</button>' +
      '<a class="pjc-wa" href="' + esc(CFG.whatsapp) + '" target="_blank" rel="noopener"><img src="' + esc(CFG.waIcon) + '" alt="" width="18" height="18">' + esc(L.wa) + '</a></div></div>';
  }
  function privacyHTML() {
    return '<p class="pjc-pv">' + esc(L.privacy) + ' <a href="' + esc(CFG.privacy) + '">' + esc(L.privacyLink) + '</a></p>';
  }
  function headerHTML() {
    var team = S.msgs.some(function (m) { return m.who === 'team' && (!S.conv || m.conv === S.conv); });
    return '<header class="pjc-h"><button type="button" class="pjc-iconbtn" data-home aria-label="' + esc(L.back) + '">' + icon('left') + '</button>' +
      '<span class="pjc-av"><img src="' + esc(CFG.head) + '" alt=""></span>' +
      '<span class="pjc-ht"><b>' + esc(tr('title')) + '</b><small>' + esc(team ? L.subTeam : L.sub) + '</small></span>' +
      '<button type="button" class="pjc-iconbtn" data-close aria-label="' + esc(L.close) + '">' + icon('x') + '</button></header>';
  }
  function chatHTML() {
    return '<div class="pjc-view pjc-chat">' + headerHTML() +
      '<div class="pjc-list" role="log" aria-live="polite"></div>' +
      '<div class="pjc-extra"></div>' +
      '<div class="pjc-comp"><button type="button" class="pjc-iconbtn pjc-plus" data-photo aria-label="' + esc(L.photo) + '">' + icon('plus') + '</button>' +
      '<textarea class="pjc-in" rows="1" placeholder="' + esc(L.placeholder) + '" aria-label="' + esc(L.placeholder) + '" enterkeyhint="send"></textarea>' +
      '<button type="button" class="pjc-iconbtn pjc-send" data-send aria-label="' + esc(L.send) + '">' + icon('up') + '</button></div>' +
      privacyHTML() + '</div>';
  }
  function downHTML() {
    return '<div class="pjc-view pjc-downv">' +
      '<header class="pjc-h"><span class="pjc-av"><img src="' + esc(CFG.head) + '" alt=""></span><span class="pjc-ht"><b>' + esc(tr('title')) + '</b><small>' + esc(L.sub) + '</small></span>' +
      '<button type="button" class="pjc-iconbtn" data-close aria-label="' + esc(L.close) + '">' + icon('x') + '</button></header>' +
      '<div class="pjc-down"><span class="pjc-down__ic">' + icon('wifioff') + '</span><h2>' + esc(L.down) + '</h2><p>' + esc(L.downSub) + '</p>' +
      '<a class="pjc-btn-wa" href="' + esc(CFG.whatsapp) + '" target="_blank" rel="noopener"><img src="' + esc(CFG.waIcon) + '" alt="" width="24" height="24">WhatsApp</a>' +
      '<button type="button" class="pjc-btn2" data-retry>' + esc(L.retry) + '</button>' +
      '<small>' + esc(tr('orMail', { email: CFG.email })) + '</small></div></div>';
  }

  var shown = null;
  function render() {
    if (!built || !S.open) return;
    var want = S.down ? 'down' : S.view;
    var key = want === 'answer' ? 'answer' + S.answer : want;
    if (key !== shown) {
      panel.innerHTML = want === 'home' ? homeHTML() : want === 'down' ? downHTML() : want === 'answer' ? answerHTML(S.answer) : chatHTML();
      panel.setAttribute('aria-label', tr('title'));
      shown = key;
      listEl = panel.querySelector('.pjc-list');
      input = panel.querySelector('.pjc-in');
    } else if (want === 'chat') {
      var h = panel.querySelector('.pjc-h');
      if (h) h.outerHTML = headerHTML();
    }
    if (want === 'chat') { renderList(); markSeen(); }
  }

  function dayLabel(ts) {
    var d = new Date(ts * 1000), t = new Date();
    var y = new Date(); y.setDate(t.getDate() - 1);
    if (d.toDateString() === t.toDateString()) return L.today;
    if (d.toDateString() === y.toDateString()) return L.yesterday;
    try { return d.toLocaleDateString(CFG.locale || LANG, { day: 'numeric', month: 'long' }); } catch (e) { return d.toDateString(); }
  }
  function attsHTML(m) {
    return m.atts.map(function (a) {
      if (a.kind === 'image') return '<a class="pjc-photo" href="' + esc(a.url) + '" target="_blank" rel="noopener"><img src="' + esc(a.thumb) + '" alt="' + esc(L.photoAlt) + '" loading="lazy"></a>';
      return '<a class="pjc-filea" href="' + esc(a.url) + '" target="_blank" rel="noopener">' + icon('file') + esc(L.file) + (a.ext ? ' · ' + esc(a.ext) : '') + '</a>';
    }).join('');
  }
  // `greeting` : le message d'accueil, écrit d'avance ici ; il ne vient pas de l'IA et ne porte donc pas son étiquette.
  function bubble(m, greeting) {
    var body = (m.text ? '<div class="pjc-bb">' + rich(m.text) + '</div>' : '') + attsHTML(m);
    if (m.who === 'me') return '<div class="pjc-r pjc-me">' + body + '</div>';
    var av = m.who === 'team'
      ? '<span class="pjc-mini pjc-mini--ini">' + esc((m.name || CFG.brand).charAt(0).toUpperCase()) + '</span>'
      : '<span class="pjc-mini"><img src="' + esc(CFG.head) + '" alt=""></span>';
    var out = '';
    if (m.who === 'team') out += '<div class="pjc-tn">' + esc(m.name ? tr('team', { name: m.name }) : tr('teamAnon')) + '</div>';
    out += '<div class="pjc-r pjc-' + m.who + '">' + av + '<div class="pjc-col">' + body + '</div></div>';
    if (m.who === 'ai' && !greeting) out += '<div class="pjc-lab">' + icon('spark') + esc(L.aiLab) + '</div>';
    return out;
  }
  function pendingHTML(p) {
    var body = (p.preview ? '<span class="pjc-photo"><img src="' + esc(p.preview) + '" alt="' + esc(L.photoAlt) + '"></span>' : '') +
      (p.text ? '<div class="pjc-bb">' + rich(p.text) + '</div>' : '');
    var st = p.state === 'failed'
      ? '<button type="button" class="pjc-fail" data-retry-p="' + esc(p.echo) + '">' + icon('retry') + esc(L.failed) + ' ' + esc(L.retry) + '</button>'
      : '<span class="pjc-sending">' + esc(L.sending) + '</span>';
    return '<div class="pjc-r pjc-me pjc-pending">' + body + '</div><div class="pjc-st">' + st + '</div>';
  }
  function renderList() {
    if (!listEl || !S.open || shown !== 'chat') return;
    var stick = listEl.scrollHeight - listEl.scrollTop - listEl.clientHeight < 80;
    var html = '';
    if (!S.loaded && S.auth && S.loading) html += '<div class="pjc-day">' + esc(L.loading) + '</div>';
    // L'API du widget ne rend que la dernière conversation : tout ce qui est en mémoire en fait partie.
    var list = S.msgs;
    var day = null, joined = false;
    if (!list.length && !(S.auth && S.loading)) {
      html += '<div class="pjc-day">' + esc(L.today) + '</div>' + bubble({ who: 'ai', text: tr('hello'), atts: [] }, true);
    }
    list.forEach(function (m) {
      var dl = dayLabel(m.at);
      if (dl !== day) { html += '<div class="pjc-day">' + esc(dl) + '</div>'; day = dl; }
      if (m.who === 'team' && !joined) {
        joined = true;
        html += '<div class="pjc-ev"><span class="pjc-evi">' + icon('user') + '</span>' + esc(L.joined) + '</div>';
      }
      html += bubble(m);
    });
    S.pending.forEach(function (p) { html += pendingHTML(p); });
    // L'IA met en général une minute : on le dit, et on n'enferme pas le visiteur dans l'attente.
    var last = list[list.length - 1];
    var waiting = !S.pending.length && last && last.who === 'me';
    if (S.typing) {
      html += typingHTML(S.typing === 'ai' ? L.typing : tr('teamTyping', { name: S.typing }));
    } else if (waiting && now() - last.at < 180) {
      html += typingHTML(L.typing) + '<p class="pjc-wait">' + esc(L.wait) + '</p>';
    } else if (waiting && now() - last.at < 3600) {
      html += '<p class="pjc-wait">' + esc(L.late) + ' <a href="' + esc(CFG.whatsapp) + '" target="_blank" rel="noopener">WhatsApp</a></p>';
    }
    if (S.notice) { html += '<p class="pjc-wait pjc-wait--err">' + esc(S.notice) + '</p>'; S.notice = null; }
    // Après une réponse de l'IA : deux réponses en un geste, comme dans l'app.
    if (!waiting && !S.pending.length && last && last.who === 'ai') {
      // Un seul geste après une réponse de l'IA : demander une personne (la routine passe alors la main à l'équipe).
      // Pas de « Ça marche, merci » : il relancerait l'IA pour rien.
      html += '<div class="pjc-chips"><button type="button" class="pjc-chip" data-human>' + icon('user') + esc(L.human) + '</button></div>';
    }
    if (!list.length && !S.pending.length) {
      html += '<div class="pjc-chips">' + L.asks.map(function (a, i) {
        return '<button type="button" class="pjc-chip" data-ans="' + i + '">' + icon(TILE_ICONS[i]) + esc(a) + '</button>';
      }).join('') + '</div>';
    }
    listEl.innerHTML = html;
    renderExtra();
    if (stick || S.pending.length) listEl.scrollTop = listEl.scrollHeight;
    var imgs = listEl.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) if (!imgs[i].complete) imgs[i].addEventListener('load', function () { if (stick) listEl.scrollTop = listEl.scrollHeight; }, { once: true });
  }
  function typingHTML(label) {
    return '<div class="pjc-r pjc-ai"><span class="pjc-mini"><img src="' + esc(CFG.head) + '" alt=""></span>' +
      '<div class="pjc-bb pjc-typing" role="status" aria-label="' + esc(label) + '"><i></i><i></i><i></i></div></div>' +
      '<div class="pjc-lab pjc-lab--typing">' + esc(label) + '</div>';
  }
  function renderExtra() {
    var x = panel && panel.querySelector('.pjc-extra');
    if (!x) return;
    var st = store.get();
    var show = CFG.mail && S.conv && !S.email && !st.mail && !st.mailNo && S.msgs.some(function (m) { return m.who === 'me'; });
    if (S.mailMsg) { x.innerHTML = '<p class="pjc-mailok">' + icon('mail') + esc(S.mailMsg) + '</p>'; return; }
    if (!show) { x.innerHTML = ''; return; }
    x.innerHTML = S.mailOpen
      ? '<form class="pjc-mail pjc-mail--open" novalidate>' + icon('mail') + '<input type="email" class="pjc-mail__in" placeholder="' + esc(L.mailPh) + '" autocomplete="email" aria-label="' + esc(L.mailPh) + '" required>' +
        '<button type="submit" class="pjc-mail__ok">' + esc(L.mailOk) + '</button><button type="button" class="pjc-mail__x" data-mail-no aria-label="' + esc(L.close) + '">' + icon('x') + '</button></form>'
      : '<div class="pjc-mail">' + icon('mail') + '<span>' + esc(L.mail) + '</span><button type="button" class="pjc-mail__btn" data-mail>' + esc(L.mailBtn) + '</button>' +
        '<button type="button" class="pjc-mail__x" data-mail-no aria-label="' + esc(L.close) + '">' + icon('x') + '</button></div>';
    var f = x.querySelector('form');
    if (f) {
      var inp = f.querySelector('input');
      inp.focus({ preventScroll: true });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = inp.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { inp.setCustomValidity(L.mailBad); inp.reportValidity(); return; }
        inp.setCustomValidity('');
        f.querySelector('button[type=submit]').disabled = true;
        // L'adresse vient du visiteur, tapée ici : c'est le seul cas où le contact ChatWoot reçoit une adresse.
        req('PATCH', '/api/v1/widget/contact', { email: v }).then(function () {
          S.email = v; S.mailOpen = false; store.set({ mail: 1 });
          S.mailMsg = L.mailSaved; renderExtra();
          setTimeout(function () { S.mailMsg = null; renderExtra(); }, 6000);
        }).catch(function () {
          f.querySelector('button[type=submit]').disabled = false;
          inp.setCustomValidity(L.failed); inp.reportValidity();
        });
      });
    }
  }

  /* ------------------------------------------------------------------ gestes */
  function onClick(e) {
    var el = e.target.closest('button, a, [data-close]');
    if (!el || !host.contains(el)) return;
    if (el.hasAttribute('data-close')) { e.preventDefault(); close(); return; }
    if (el.hasAttribute('data-home')) { S.view = 'home'; render(); return; }
    if (el.hasAttribute('data-write')) { S.view = 'chat'; render(); focusInput(); return; }
    // Les cases et les sujets ouvrent une réponse rapide : rien ne part chez ChatWoot, l'IA ne travaille pas.
    if (el.hasAttribute('data-ans')) { S.answer = +el.getAttribute('data-ans'); S.view = 'answer'; render(); return; }
    if (el.hasAttribute('data-human')) { send(L.humanText); return; }
    if (el.hasAttribute('data-send')) { submit(); return; }
    if (el.hasAttribute('data-photo')) { fileIn.click(); return; }
    if (el.hasAttribute('data-retry')) { S.down = false; S.view = S.msgs.length || S.pending.length ? 'chat' : 'home'; render(); if (S.auth) loadThread(); retryAll(); return; }
    if (el.hasAttribute('data-retry-p')) {
      var p = S.pending.filter(function (x) { return x.echo === el.getAttribute('data-retry-p'); })[0];
      if (p) deliver(p);
      return;
    }
    if (el.hasAttribute('data-mail')) { S.mailOpen = true; renderExtra(); return; }
    if (el.hasAttribute('data-mail-no')) { S.mailOpen = false; store.set({ mailNo: 1 }); renderExtra(); return; }
  }
  function retryAll() { S.pending.forEach(function (p) { if (p.state === 'failed') deliver(p); }); }
  function submit() {
    if (!input) return;
    var v = input.value;
    if (!v.trim()) return;
    input.value = '';
    autosize();
    var s = panel.querySelector('.pjc-send');
    if (s) s.classList.remove('is-on');
    typingOff();
    send(v);
    focusInput();
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.target === input && e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); submit(); }
  }
  var typingSent = 0, typingIdle = null;
  function onInput(e) {
    if (e.target !== input) return;
    autosize();
    var s = panel.querySelector('.pjc-send');
    if (s) s.classList.toggle('is-on', !!input.value.trim());
    // « En train d'écrire » chez l'équipe : une fois toutes les 10 s au plus, éteint après 3 s sans frappe.
    if (S.conv && S.auth && Date.now() - typingSent > 10000) {
      typingSent = Date.now();
      req('POST', '/api/v1/widget/conversations/toggle_typing', { typing_status: 'on' }).catch(function () {});
    }
    clearTimeout(typingIdle);
    typingIdle = setTimeout(typingOff, 3000);
  }
  function typingOff() {
    clearTimeout(typingIdle);
    if (!typingSent || !S.conv || !S.auth) return;
    typingSent = 0;
    req('POST', '/api/v1/widget/conversations/toggle_typing', { typing_status: 'off' }).catch(function () {});
  }
  function autosize() {
    if (!input) return;
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 132) + 'px';
  }
  function focusInput() {
    if (input && !mobile.matches) input.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------------ ouvrir, fermer */
  // Téléphone : la feuille suit le clavier (visualViewport), et la page derrière ne défile plus.
  function fitViewport() {
    var vv = window.visualViewport;
    if (!S.open || !mobile.matches || !vv) { host.style.removeProperty('top'); host.style.removeProperty('height'); return; }
    host.style.top = vv.offsetTop + 'px';
    host.style.height = vv.height + 'px';
    if (listEl && document.activeElement === input) listEl.scrollTop = listEl.scrollHeight;
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitViewport);
    window.visualViewport.addEventListener('scroll', fitViewport);
  }
  function open(view) {
    if (S.open) { if (view) { S.view = view; render(); } return; }
    build();
    S.open = true;
    S.view = view || (S.msgs.length || S.pending.length || (S.auth && store.get().conv) ? 'chat' : 'home');
    host.hidden = false;
    wrap.classList.add('is-open');
    tab.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('pj-chat-open');
    try { sessionStorage.setItem('pj_chat_open', '1'); } catch (e) {}
    try { localStorage.setItem('pj_chat_vu', String(Date.now())); } catch (e) {}
    shown = null;
    render();
    fitViewport();
    if (S.auth && !S.loaded) loadThread();
    if (S.view === 'chat') focusInput();
    else { var x = panel.querySelector('[data-close].pjc-x, .pjc-x'); if (x && !mobile.matches) x.focus({ preventScroll: true }); }
  }
  function close() {
    if (!S.open) return;
    S.open = false;
    typingOff();
    host.hidden = true;
    wrap.classList.remove('is-open');
    tab.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('pj-chat-open');
    try { sessionStorage.removeItem('pj_chat_open'); } catch (e) {}
    fitViewport();
    tab.focus({ preventScroll: true });
  }

  tab.addEventListener('click', function () { if (S.open) close(); else open(); });
  // Le lien « Chat » de la page contact et tout élément marqué data-pj-chat ouvrent le chat.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.ct-chan--chat, [data-pj-chat]');
    if (!t) return;
    e.preventDefault();
    open();
  });
  // Un visiteur qui a une conversation en cours : on la relit une fois la page chargée, pour la pastille des réponses
  // arrivées entre deux pages, et on rouvre le chat s'il était ouvert sur la page d'avant.
  function boot() {
    var st = store.get();
    var legacy = 0;
    try { legacy = Number(localStorage.getItem('pj_chat_vu') || 0); } catch (e) {}
    var recent = (st.conv && now() - st.conv < 30 * 86400) || (legacy && Date.now() - legacy < 7 * 864e5);
    var reopen = false;
    try { reopen = sessionStorage.getItem('pj_chat_open') === '1'; } catch (e) {}
    if (S.auth && recent) {
      setTimeout(function () { loadThread().then(function () { if (reopen && (S.msgs.length || S.pending.length)) open('chat'); }); }, reopen ? 0 : 1200);
    }
  }
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);

  window.PJChat = { open: open, close: close };
})();
